export default __webpack_public_path__ + "static/media/close.5883459c.svg";